import React, { useState, useEffect } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { components } from "react-select";
import { SelectLoadingMessage } from "../UI/loading";

/** Custom Input that listens to paste */
const CustomInput = (props) => {
  const { onPaste } = props.selectProps; // pick up onPaste from AsyncSearchInput props
  return (
    <components.Input
      {...props}
      onPaste={(e) => {
        if (onPaste) {
          onPaste(e); // call the handler passed from parent
        }
        if (props.onPaste) {
          props.onPaste(e);
        }
      }}
    />
  );
};

function AsyncSearchInput({
  loadMoreOptions,
  shouldLoadMore,
  key,
  id,
  options,
  name,
  label,
  value,
  isDisabled,
  getOptionLabel,
  getOptionValue,
  customStyles,
  onChange,
  isMulti,
  onMenuOpen,
  onMenuClose,
  menuIsOpen,
  menuStyle,
  menuPosition = 'fixed',
  menuPlacement = 'bottom',
  menuPortalTarget = typeof document !== 'undefined' ? document.body : null,
  placeholder,
  tabIndex,
  onPaste,
  applySelectedStyles,
  defaultOptions,
}) {
  const [isSelected, setIsSelected] = useState(!!value);

  useEffect(() => {
    if (isMulti) {
      setIsSelected(Array.isArray(value) && value.length > 0);
    } else {
      setIsSelected(!!value);
    }
  }, [value, isMulti]);

  const combinedStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "35px",
      fontSize: "12px",
      border: '1px solid #bcc3c7',
      borderColor: '#bcc3c7',
      borderRadius: '5px',
      backgroundColor: 'transparent',
      boxShadow: state.isFocused
        ? '0 0 0 1px rgba(188, 195, 199, 0.75)'
        : 'none',
      '&:hover': {
        borderColor: '#bcc3c7',
      },
      ...(customStyles && customStyles.control),
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    container: (provided) => ({
      ...provided,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 99,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
      ...(customStyles && customStyles.menuPortal),
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <AsyncPaginate
      label={label}
      key={key}
      id={id}
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      onMenuOpen={onMenuOpen}
      onMenuClose={onMenuClose}
      isMulti={isMulti}
      menuIsOpen={menuIsOpen}
      menuPlacement={menuPlacement}
      menuPosition={menuPosition}
      menuPortalTarget={menuPortalTarget}
      menuStyle={menuStyle}
      tabIndex={tabIndex}
      debounceTimeout={500}
      isDisabled={isDisabled}
      defaultOptions={defaultOptions}
      loadOptions={(search) => loadMoreOptions(search)}
      shouldLoadMore={(scrollHeight, clientHeight, scrollTop) =>
        shouldLoadMore(scrollHeight, clientHeight, scrollTop)
      }
      components={{
        Input: CustomInput,
        LoadingMessage: SelectLoadingMessage,
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#f3f4f6",
          primary: "#ec171c",
          primary50: "#FCAEAE",
          neutral20: "#7a869a",
        },
      })}
      isSearchable={true}
      isClearable={true}
      placeholder={placeholder}
      styles={{
        ...combinedStyles,
      }}
      onPaste={onPaste}
    />
  );
}

export default AsyncSearchInput;